import { CommentIcon } from '../../../../utils/common/variables';
import useDiaryCommentInfinityQuery from '../../../../utils/hook/react-query/recipe/useDiaryCommentInfinityQuery';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsComment = () => {
  const { diary, setShowComments } = useDiaryShortsContext();
  const { totalDiaryCount } = useDiaryCommentInfinityQuery(diary.id);

  return (
    <button
      onClick={() => setShowComments(true)}
      className="h-48px w-48px shrink-0"
      type="button"
    >
      <div className="flex items-center">
        <img src={CommentIcon.white.outline_32x32} alt="좋아요" />
        <p className="text-12px text-white">{totalDiaryCount}</p>
      </div>
    </button>
  );
};

export default _DiaryShortsComment;
